/** @jsx jsx */
import { Dialog } from '@datacamp/waffles/dialog';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import { t } from 'i18next';

import config from '../../config';

const COURSES_LINK = `${config.urls.learn}/courses`;

export const ArchivedResourceModal = () => {
  return (
    <div data-cy="archived-resource-modal">
      <Dialog.Header>{t('ArchivedResourceModal.header')}</Dialog.Header>
      <Dialog.Body>
        <p>{t('ArchivedResourceModal.text')}</p>
      </Dialog.Body>
      <Dialog.Footer css={{ justifyContent: 'center' }}>
        <Dialog.Button
          href={COURSES_LINK}
          as="a"
          variant="primary"
          css={{
            ':hover': {
              borderColor: 'transparent',
              color: tokens.colors.navy,
            },
          }}
        >
          {t('ArchivedResourceModal.cta')}
        </Dialog.Button>
      </Dialog.Footer>
    </div>
  );
};
